import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEqual } from 'lodash';
import { Modal, Button } from 'react-bootstrap';

import Actions from '@redux/payments';

const TABS = [0, 1, 2, 3];

class RkPayTourModal extends Component {
	shouldComponentUpdate = ({ showModal, activeTourTab }) => {
		const lastProps = this.props;

		return (
			!isEqual(showModal, lastProps.showModal)
			|| !isEqual(activeTourTab, lastProps.activeTourTab)
		);
	};

	handleOnClick = (type) => {
		const {
			updateStoreProperties,
			activeTourTab,
		} = this.props;

		if (type === 'back' && activeTourTab > 0) updateStoreProperties({ activeTourTab : activeTourTab - 1 });
		else if (activeTourTab < 3) updateStoreProperties({ activeTourTab : activeTourTab + 1 });
		else if (type === 'next') this.closeModal();
	}

	closeModal = () => {
		const { updateModalState, updateStoreProperties } = this.props;
		updateModalState('tourModal', false);
		updateStoreProperties({ activeTourTab : 0 });
	}

	renderTitleText = (text, index) => (<p className="font-size-14 color-default margin-top-10 margin-bottom-0" key={`title_text_${index}`}>{ text }</p>)

	renderIndicator = (active) => (
		<div className="width-380 display-inline-block text-center">
			{
				TABS.map((tab) => (
					<i
						key={tab}
						className={`fa fa-circle font-size-16 margin-left-5 margin-right-5 ${active === tab ? 'text-primary' : 'color-blue-blizzard'}`}
					/>
				))
			}
		</div>
	)

	render() {
		const { showModal, activeTourTab } = this.props;

		return (
			<Modal
				bsSize="large"
				show={showModal}
				onHide={this.closeModal}
			>
				<Modal.Header className="border-none">
					<button
						className="close"
						onClick={this.closeModal}
						type="button"
					>
						<i className="rkfm rkfm-cross-circle" />
					</button>
					<h2 className="text-center color-dark margin-0">
						<Choose>
							<When condition={activeTourTab === 0}>
								Pending Review
								{ this.renderTitleText('Invoices that are currently waiting on your review can be found here.', 1) }
								{ this.renderTitleText('These need your approval before they can be paid.', 2) }
							</When>
							<When condition={activeTourTab === 1}>
								Awaiting Payment
								{ this.renderTitleText('Once you\'ve approved an invoice, it\'s time to pay it. Choose to pay when you', 3) }
								{ this.renderTitleText('approve, or pay later. Batch invoices together or simply pay them one at a time.', 4) }
							</When>
							<When condition={activeTourTab === 2}>
								Dispute
								{ this.renderTitleText('Get a quick glimpse of all invoices you have questions', 5) }
								{ this.renderTitleText('or concerns about.', 6) }
							</When>
							<Otherwise>
								Invoice History
								{ this.renderTitleText('Get a quick snapshot of your invoice history, or do a full audit quickly. With expansive', 7) }
								{ this.renderTitleText('filters and deep dives, you can get the information you need when you need it.', 8) }
							</Otherwise>
						</Choose>
					</h2>
				</Modal.Header>
				<Modal.Body className="flex-center padding-0">
					{
						TABS.map((tab) => (
							<img
								key={tab}
								src={`/images/rk-pay-tour-${tab + 1}.png`}
								className={`rk-pay-tour-image ${tab === 0 ? 'margin-bottom--15' : ''} ${tab !== activeTourTab ? 'hidden' : ''}`}
								alt="rkpay-tour-tab"
							/>
						))
					}
				</Modal.Body>
				<Modal.Footer className="flex-center border-none">
					<Button
						onClick={() => this.handleOnClick('back')}
						className={activeTourTab === 0 ? 'visibility-hidden' : ''}
					>
						Back
					</Button>
					{ this.renderIndicator(activeTourTab) }
					<Button
						onClick={() => this.handleOnClick('next')}
					>
						{ activeTourTab === 3 ? 'Got It' : 'Next' }
					</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

const mapStateToProps = ({
	payments : {
		modals : { tourModal : showModal },
		activeTourTab,
	},
}) => ({
	showModal,
	activeTourTab,
});

const mapDispatchToProps = (dispatch) => ({
	dispatch,
	updateModalState      : bindActionCreators(Actions, dispatch).updateModalState,
	updateStoreProperties : bindActionCreators(Actions, dispatch).updateStoreProperties,
});

RkPayTourModal.propTypes = {
	activeTourTab         : PropTypes.number,
	showModal             : PropTypes.bool,
	updateModalState      : PropTypes.func.isRequired,
	updateStoreProperties : PropTypes.func.isRequired,
};

RkPayTourModal.defaultProps = {
	activeTourTab : 0,
	showModal     : false,
};

export default connect(mapStateToProps, mapDispatchToProps)(RkPayTourModal);
